import { Injectable } from '@angular/core';
import { UserCartService } from './user-cart.service';
import { Subject, catchError, tap } from 'rxjs';
import { ResponseState } from 'src/app/core/models/api-response.model';
import { commonService } from 'src/app/core/services/common.service';
import { ItemPlace } from 'src/app/site/shared-components/item-location-overlay/models/model';
import { AddToCartModel } from '../models/user-cart.models';
import { ItemModel } from '../models/item.model';
import { Store } from '@ngxs/store';
import { AddToCart } from 'src/app/core/store/cart/cart.action';

@Injectable({
  providedIn: 'root',
})
export class CartBlService {
  warning: Subject<string> = new Subject<string>();
  constructor(
    private readonly userCartService: UserCartService,
    private common: commonService ,
    private store : Store
  ) {}

  addOrUpdateCart(item: ItemModel) {
    // console.log(item);
    let cartItem: AddToCartModel = {
      item: {
        itemId: item.itemId,
        cartItemId: item.cartItemId,
        unitId: item.unitId,
        appointment: item.appointment
          ? {
              date: item.appointment.date,
              time: item.appointment.time,
              employeeIds: item.appointment.employees.map((e) => e.id),
              itemPlace: this.common.getItemPlace() ?? ItemPlace.OnSite,
            }
          : null,
        quantity: item.quantity,
        isForMe: item.isForMe,
        children: item.children?.map((c) => ({
          itemId: c.itemId,
          appointment: c.appointment
            ? {
                date: c.appointment.date,
                time: c.appointment.time,
                employeeIds: c.appointment.employees.map((e) => e.id),
                itemPlace: this.common.getItemPlace() ?? ItemPlace.OnSite,
              }
            : null,
          quantity: 1,
        })),
      },
    };
    if (item.phoneNumber && item.countryCode) {
      cartItem.item.recipient = {
        mobile: item.phoneNumber,
        countryCode: item.countryCode,
      };
    }
    // // this.common.loading$.next(true);
    // return this.userCartService.addToCart(cartItem).pipe(
    //   tap((res) => {
    //     this.common.loading$.next(false);
    //   }),
    //   catchError((err) => {
    //     this.common.loading$.next(false);
    //     this.handleErrors(err);
    //     throw err;
    //   })
    // );
    return this.store.dispatch(new AddToCart(cartItem));
  }

  handleErrors(err: any) {
    if (err?.status === 422) {
      if (
        err?.error?.state == ResponseState.ClientHaveAppointmentOnTheSameTime ||
        err?.error?.state == ResponseState.EmployeeHaveAppointmentOnTheSameTime
      ) {
        this.warning.next(err?.error?.message);
      } else {
        //this.common.toasterType$.next('error');
        //this.common.toaster$.next(err?.error?.message);
      }
    }
  }

  deleteItem(cartItemId: number) {
    this.common.loading$.next(true);
    return this.userCartService.deleteCartItem(cartItemId).pipe(
      tap((res) => {
        this.common.loading$.next(false);
      }),
      catchError((err) => {
        this.common.loading$.next(false);
        throw err;
      })
    );
  }

  clearCart() {
    this.common.loading$.next(true);
    return this.userCartService.clearCart().pipe(
      tap((res) => {
        this.common.loading$.next(false);
      }),
      catchError((err) => {
        this.common.loading$.next(false);
        throw err;
      })
    );
  }
}
